export default "__VITE_ASSET__ef5f5422__"